import {
  Snackbar,
  Alert,
  Card,
  CircularProgress,
  Backdrop,
  Icon,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Tooltip,
  Table,
  TableRow,
  TableCell,
  Grid,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";
import usePageTitle from "app/pageTitle";

import MDInput from "theme/components/MDInput";
import MDButton from "theme/components/MDButton";
import DataTable from "theme/Tables/DataTable";
import axios from "axios.js";
import { useAwaitDialog } from "app/components/status_dialog";

function VoiceNumbersPage() {
  const pageTitle = "Voice - Numbers";
  usePageTitle(pageTitle);
  const navigate = useNavigate();

  const statusDialog = useAwaitDialog();
  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };
  const [refreshPage, setRefreshPage] = useState(false);
  const [pageLoaded, setPageLoaded] = useState(false);

  const [currency, setCurrency] = useState(null);
  const [resultData, setResultData] = useState({});
  const [numbers, setNumbers] = useState([]);
  const [topupAmount, setTopupAmount] = useState(null);
  const [selectedNumber, setSelectedNumber] = useState(null);
  const [openTopupDialog, setOpenTopupDialog] = useState(false);
  const [openBuyDialog, setOpenBuyDialog] = useState(false);

  const tableColumns = [
    { Header: "Name", accessor: "title", align: "left" },
    { Header: "Number", accessor: "number", align: "left" },
    { Header: "Balance", accessor: "balance", align: "left" },
    { Header: "Actions", accessor: "actions", align: "right" },
  ];

  const buildRows = (data) => {
    const rows = [];
    data.map((row) => {
      rows.push({
        title: row.title,
        number: row.phone_number,
        balance: `${(row.balance / 100).toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}`,
        actions: (
          <MDBox mt={1} variant="button">
            <MDButton
              size="small"
              variant="contained"
              color="success"
              onClick={() => {
                setTopupAmount(null);
                setSelectedNumber(row.reference);
                setOpenTopupDialog(true);
              }}
              startIcon={
                <Icon sx={{ cursor: "pointer" }} fontSize="small">
                  add
                </Icon>
              }
            >
              Topup
            </MDButton>
            {/* &nbsp;
            <MDButton
              size="small"
              variant="outlined"
              color="error"
              iconOnly
              onClick={() => {
                if (window.confirm(`Delete?`) === true) {
                  // deleteProduct(row.reference);
                }
              }}
            >
              <Icon sx={{ cursor: "pointer" }} fontSize="small">
                delete
              </Icon>
            </MDButton> */}
          </MDBox>
        ),
        // created: row.created,
      });
      return null;
    });

    return rows;
  };

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get(`/portal/voice/numbers.json`)
        .then((result) => {
          // console.log(result.data.data.campaign.activation);
          setShowLoading(false);
          if (result.data.status === "success") {
            setCurrency(result.data.currency);
            setResultData(result.data.data);

            const rows = buildRows(result.data.data.numbers);
            setNumbers(rows);

            setPageLoaded(true);
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg(
            `Unable to complete request. ${
              navigator.onLine ? "" : "Make sure you have an active internet connection"
            }`
          );
          setOpen(true);
        });
    };

    fetchData();
  }, [refreshPage]);

  async function topup() {
    if (selectedNumber === null) {
      setSeverity("error");
      setErrMsg("Select a number");
      setOpen(true);
      return;
    }

    if (topupAmount === null) {
      setSeverity("error");
      setErrMsg("Enter a valid amount.");
      setOpen(true);
      return;
    }

    setOpenTopupDialog(false);
    setShowLoading(true);
    const json = {
      reference: selectedNumber,
      amount: parseInt(topupAmount, 10) * 100,
    };

    await axios
      .post("portal/voice/numbers/topup.json", json)
      .then(async (result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          await statusDialog.show(result.data.data.message, "success", "Topup Success!");
          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function buy() {
    setOpenBuyDialog(false);
    setShowLoading(true);
    await axios
      .get("portal/voice/numbers/purchase.json")
      .then(async (result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          await statusDialog.show(result.data.data.message, "success", "Success!");
          setRefreshPage(!refreshPage);
        } else {
          await statusDialog.show(result.data.data.message, "error", "Failed!");
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>

      <Dialog open={openBuyDialog} fullWidth maxWidth="xs">
        <DialogTitle>
          <MDBox>Buy a Number</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox>
            <MDBox>
              <Table>
                <TableRow>
                  <TableCell>
                    <MDTypography fontSize={14}>Price</MDTypography>
                  </TableCell>
                  <TableCell>
                    <MDTypography align="right" fontSize={14}>
                      {`${currency}${(resultData.fee / 100).toLocaleString("en", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}`}
                    </MDTypography>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    <MDTypography fontSize={14}>VAT</MDTypography>
                  </TableCell>
                  <TableCell>
                    <MDTypography align="right" fontSize={14}>
                      {`${currency}${(resultData.vat / 100).toLocaleString("en", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}`}
                    </MDTypography>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    <MDTypography fontSize={14} fontWeight="bold">
                      Total
                    </MDTypography>
                  </TableCell>
                  <TableCell>
                    <MDTypography align="right" fontSize={14} fontWeight="bold">
                      {`${currency}${((resultData.fee + resultData.vat) / 100).toLocaleString(
                        "en",
                        {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        }
                      )}`}
                    </MDTypography>
                  </TableCell>
                </TableRow>
              </Table>
            </MDBox>
            <MDBox mt={3}>
              <Alert severity="warning">
                <MDTypography variant="h6" fontSize={12}>
                  Inactive numbers will be recycled after 90 days.
                </MDTypography>
              </Alert>
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenBuyDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="dark"
            variant="contained"
            onClick={() => {
              buy();
            }}
          >
            Buy Number
          </MDButton>
        </DialogActions>
      </Dialog>

      <Dialog open={openTopupDialog} fullWidth maxWidth="xs">
        <DialogTitle>
          <MDBox>Topup Call Credits</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox>
            <MDBox mt={2}>
              <MDInput
                name="title"
                margin="dense"
                label="Amount"
                type="text"
                fullWidth
                variant="outlined"
                onChange={(e) => setTopupAmount(e.target.value)}
              />
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenTopupDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="dark"
            variant="contained"
            onClick={() => {
              topup();
            }}
          >
            Topup
          </MDButton>
        </DialogActions>
      </Dialog>
      <MDBox mt={1} mb={5}>
        {pageLoaded && (
          <MDBox>
            <MDBox>
              <Card sx={{ height: "100%", marginTop: "0px" }}>
                <MDBox p={1}>
                  <MDBox align="center">
                    <MDBox>
                      <MDTypography variant="h6" fontSize={48}>
                        <Icon>add_ic_call</Icon>
                      </MDTypography>
                      <MDTypography variant="h6" fontWeight="bold" fontSize={16}>
                        Phone Numbers
                      </MDTypography>
                      <MDTypography mt={1} variant="h6" fontWeight="light" fontSize={16}>
                        Transform your business calls with LaddarVoice
                        <br />
                        Monitor calls, track team performance and access AI powered call analytics.
                      </MDTypography>
                    </MDBox>
                    <MDBox mt={3}>
                      <MDButton
                        variant="contained"
                        color="dark"
                        onClick={() => {
                          setOpenBuyDialog(true);
                        }}
                        startIcon={<Icon>add</Icon>}
                      >
                        Buy A Number
                      </MDButton>
                    </MDBox>
                    <MDBox mt={5} align="center" mb={3}>
                      <Grid
                        container
                        spacing={{
                          xs: 2,
                          md: 4,
                          lg: 4,
                        }}
                        justifyContent="center"
                        sx={{ margin: "0 auto" }}
                      >
                        <Grid item xs={6} md={3.5} lg={3.5}>
                          <Card sx={{ height: "100%", marginTop: "0px" }} elevation={5}>
                            <MDBox
                              p={2}
                              onClick={() => {
                                navigate("/voice/business-lines");
                              }}
                            >
                              <MDTypography variant="h6" fontSize={24}>
                                <Icon>phone</Icon>
                              </MDTypography>
                              <MDTypography variant="h6" fontWeight="regular" fontSize={16}>
                                Business Lines
                              </MDTypography>
                              <MDTypography variant="h6" fontWeight="light" fontSize={16}>
                                Manage multiple business lines
                              </MDTypography>
                              <MDBox mt={3}>
                                <MDButton
                                  variant="contained"
                                  color="dark"
                                  onClick={() => {
                                    navigate("/voice/business-lines");
                                  }}
                                  iconOnly
                                >
                                  <Icon>east</Icon>
                                </MDButton>
                              </MDBox>
                            </MDBox>
                          </Card>
                        </Grid>
                        <Grid item xs={6} md={3.5} lg={3.5}>
                          <Card sx={{ height: "100%", marginTop: "0px" }} elevation={5}>
                            <MDBox
                              p={2}
                              onClick={() => {
                                navigate("/voice/call-centers");
                              }}
                            >
                              <MDTypography variant="h6" fontSize={24}>
                                <Icon>dialer_sip</Icon>
                              </MDTypography>
                              <MDTypography variant="h6" fontWeight="regular" fontSize={16}>
                                Call Center
                              </MDTypography>
                              <MDTypography variant="h6" fontWeight="light" fontSize={16}>
                                Manage multiple call centers
                              </MDTypography>
                              <MDBox mt={3}>
                                <MDButton
                                  variant="contained"
                                  color="dark"
                                  onClick={() => {
                                    navigate("/voice/call-centers");
                                  }}
                                  iconOnly
                                >
                                  <Icon>east</Icon>
                                </MDButton>
                              </MDBox>
                            </MDBox>
                          </Card>
                        </Grid>
                      </Grid>
                    </MDBox>
                  </MDBox>
                </MDBox>
              </Card>
            </MDBox>
            <MDBox mt={5}>
              <Card sx={{ height: "100%", marginTop: "0px" }}>
                <MDBox>
                  <MDBox p={2}>
                    <MDBox display="flex" justifyContent="space-between" alignItems="center">
                      <MDBox>
                        <MDTypography variant="h6" fontWeight="medium" textTransform="capitalize">
                          Phone Numbers
                        </MDTypography>
                      </MDBox>
                      <MDBox>
                        {/* <MDButton
                            variant="contained"
                            color="dark"
                            iconOnly
                            onClick={() => {
                              setProductTitle(null);
                              setProductSampleQuantity(null);
                              setProductQuantity(null);
                              setProductPrice(null);
  
                              setProductAction("create");
                              setOpenAddProductDialog(true);
                            }}
                          >
                            <Icon>add</Icon>
                          </MDButton> */}
                      </MDBox>
                    </MDBox>
                  </MDBox>
                  <MDBox p={0}>
                    <DataTable
                      table={{ columns: tableColumns, rows: numbers }}
                      isSorted
                      entriesPerPage={false}
                      showTotalEntries
                      buttons
                      noEndBorder
                    />
                  </MDBox>
                </MDBox>
              </Card>
            </MDBox>
          </MDBox>
        )}
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default VoiceNumbersPage;
